import React, { useState } from "react";
import { PropTypes } from "prop-types";
import { BtnSimple } from "../../_atoms/_btn-simple/BtnSimple.js";
import { Form } from "../../_molecules/_form/Form";
import { FormSelectSimple } from "../../_atoms/_form-input-simple/FormSelectSimple";

import "./_specsheet.scss";

export const SpecSheet = ({
  title,
  price,
  subtitle,
  children,
  button,
  type,
  link,
  small,
  aria,
  specs,
  duration,
  onClick,
  onChange,
  showSelect,
  selectText,
  monthly,
  originalPrice,
}) => {
  const [isListActive, setListActive] = useState(false);

  //converitmos el objeto a un array para poder mapearlo
  const specsArray = Object.values(specs);
  
  const renderList = () => {
    if (isListActive) {
      return (
        <div className="specsheet__include-content">
          <ul className="list list--icons list--icons--xs">
            {specsArray.map((item, i) => (
              <li key={i}>
                <div className="text">
                  <svg className="icon">
                    <use xlinkHref="./svg/sprite.svg#check-unfilled"></use>
                  </svg>
                  {item}
                </div>
              </li>
            ))}
          </ul>
          <small>{small}</small>
        </div>
      );
    }
    return null; // No se renderiza la lista si isListActive es false
  };

  return (
    <div className="specsheet__container">
      {!duration && <span className="h3">{title}</span>}
      {duration && (
        <div className="specsheet__price">
          <div className="specsheet specsheet__price-title">
          <span className="h3">{title}</span>
          <div className={`specsheet__price-duration ${originalPrice !== price ? 'price_modifier' : ''} `}>
          <span className="h2">
            {originalPrice !== price && (
              <p className="specsheet__price-duration-price">{originalPrice} € ó</p>
            )}
            {price.toString().length === 4 ? price.toString().substring(0, 1) + '.' + price.toString().substring(1) : price}€{monthly && "/mes"}{" "}
            {monthly && <sup>2</sup>}
          </span>
          <span className="h5">{duration}</span>
          </div>
          </div>
          <hr className="specsheet__price-hr"/>
          <div className=" specsheet specsheet__price-cuote">
          {!showSelect && <span>Cuota anual</span>}
          {showSelect && (
            <Form css="form--simple">
              <span>
                  Calcula tu cuota sin intereses con BMW Bank GmbH S.E{" "}
                  <strong>TAE 0%</strong> TIN 0% <sup>2</sup>
                </span>
              <fieldset>
                {showSelect && (
                  <FormSelectSimple
                    label="Elige tu cuota"
                    name="cuota"
                    onChange={onChange}
                    hideDefault={true}
                  >
                    <option value="annual">Sin financiar</option>

                    <option value="month" selected={monthly ? "selected" : ""}>
                      {selectText}
                    </option>
                  </FormSelectSimple>
                )}
              </fieldset>
            </Form>
          )}
          </div>
        </div>
      )}
      <div className=" specsheet__include">
      <div className="border">
        <button
        className="specsheet__include-btn"
        type="button"
        onClick={() => setListActive(!isListActive)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path fill-rule="evenodd" d="M12.175 19.91c-4.537 0-8.229-3.691-8.229-8.228s3.692-8.229 8.229-8.229c4.537 0 8.228 3.692 8.228 8.229 0 4.537-3.691 8.228-8.228 8.228m0-17.828c-5.302 0-9.6 4.298-9.6 9.6s4.298 9.6 9.6 9.6 9.6-4.298 9.6-9.6-4.298-9.6-9.6-9.6m2.286 12.571h-1.6V9.604c0-.379-.307-.686-.686-.686-.04 0-.077.005-.114.012-.038-.007-.076-.011-.115-.012h-1.371c-.245 0-.472.131-.594.343-.123.212-.123.474 0 .686.122.212.349.343.594.343h.914v4.363h-1.6c-.379 0-.686.307-.686.686 0 .379.307.686.686.686h4.572c.378 0 .685-.307.685-.686 0-.379-.307-.686-.685-.686m-2.286-6.296c.378 0 .686-.279.686-.624 0-.343-.308-.623-.686-.623-.379 0-.686.28-.686.623 0 .345.307.624.686.624"/>
           </svg>
          <span className="">{subtitle}</span>
        </button>
      </div>
    
      {renderList()}
      
      </div>
    </div>
    
  );
};

SpecSheet.propTypes = {
  title: PropTypes.string.isRequired,
};
